import Stack from 'src/components-v2/Layout/Stack/Stack';
import CmsMediaSwitch from 'src/components-v2/Media/CmsMediaSwitch/CmsMediaSwitch';
import styled from 'threads5/styles/styled';

export const StyledContainer = styled('div')({
  position: 'relative',
  isolation: 'isolate',
  borderRadius: '24px',
  overflow: 'hidden',
  minHeight: '258px',
});

export const StyledBackgroundBox = styled('div')({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '& .lazyload-wrapper': {
    width: '100%',
    height: '100%',
  },
});

export const StyledContentStack = styled(Stack)(({ theme }) => {
  return {
    position: 'relative',
    zIndex: 1,
    flexGrow: 1,
    height: 'auto',
    padding: '24px',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      minHeight: '258px',
      justifyContent: 'center',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '& p:nth-last-of-type(1):empty': {
      display: 'none',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '& [class*="cms-btn-"], .btn': {
      marginTop: '16px',
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
      },
    },
  };
});

export const StyledImageStack = styled(Stack)({
  position: 'relative',
  zIndex: 1,
  height: 'auto',
});

export const StyledMediaSwitch = styled(CmsMediaSwitch)(({ theme }) => {
  return {
    minWidth: '100%',
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      minWidth: '320px',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: '430px',
    },
  };
});
